import { render } from "./ViewContainer.vue?vue&type=template&id=7dd2c4e2"
import script from "./ViewContainer.vue?vue&type=script&lang=js"
export * from "./ViewContainer.vue?vue&type=script&lang=js"

import "./ViewContainer.vue?vue&type=style&index=0&id=7dd2c4e2&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__